const BASKET_TABLE_COLUMNS = ['product__name', 'total', 'Floor', 'Zone', 'Colour / Finish', 'condition'];

export default BASKET_TABLE_COLUMNS;
